// document.addEventListener("DOMContentLoaded", function () {
//   const hoverContents = document.querySelectorAll(".hover-image-container");
//   const mainImageContainer = document.querySelector(".image-wrapper");
//   const mainImage = mainImageContainer.querySelector("img"); // Select the existing image

//   hoverContents.forEach((content) => {
//     content.addEventListener("mouseenter", function () {
//       const hoverImage = this.getAttribute("data-hover-image");
//       if (hoverImage) {
//         mainImage.src = hoverImage;
//         console.log(mainImage.src, "hover-image")
//       }
//     });

//     content.addEventListener("mouseleave", function () {
//       const mainImageSrc = mainImageContainer.getAttribute("data-main-image"); // Get main image from parent
//       if (mainImageSrc) {
//         mainImage.src = mainImageSrc;
//         console.log(mainImage.src, "main-image")
//       }
//     });
//   });
// });
const hoverContents = document.querySelectorAll('.hover-image-container');
  hoverContents?.forEach((content) => {
    content.addEventListener('mouseenter', () => {
      const hoverImage = content.getAttribute('data-hover-image')
      const mainImage = document.querySelector('.image-wrapper');
      const previousImage = mainImage.querySelector('img');
      const hoveringImg = document.createElement('img');
      hoveringImg.src = hoverImage
      previousImage.remove();
      mainImage.appendChild(hoveringImg)
    })
    content.addEventListener('mouseleave', () => {
      const hoverImage = content.getAttribute('data-main-image')
      const mainImage = document.querySelector('.image-wrapper');
      const previousImage = mainImage.querySelector('img');
      const hoveringImg = document.createElement('img');
      hoveringImg.src = hoverImage
      previousImage.remove();
      mainImage.appendChild(hoveringImg)
    })
  })